import styled, { keyframes } from 'styled-components';

const Arrow = styled.button`
display: flex; 
align-items: center;
justify-content: center;
width: 40px;
height: 40px;
margin: 0 5px;
cursor: pointer;
transition: all .3s;
border-radius: 50%;
border: none;
line-height: normal;
background-color: ${({ background }) => background} ;

&:hover {
  border-radius: 50%;
  background-color: #EBEBF0;
  box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
}

&:disabled {
   opacity: 0.3 !important;
   cursor: not-allowed;
   box-shadow: none;
}
`;

const LeftArrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: absolute;
  left: 2px;
  top: 50%;
  margin-top: 17px;
  transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  padding: 0;
  line-height: normal;
  background-color: #269EE2;

  &:hover {
    opacity: 0.95 !important;
    border-radius: 50%;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
    opacity: 0.3 !important;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const RightArrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: absolute;
  right: 2px;
  top: 50%;
  margin-top: 17px;
  transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  padding: 0;
  line-height: normal;
  background-color: #269EE2;

  &:hover {
    opacity: 0.95 !important;
    border-radius: 50%;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
    opacity: 0.3 !important;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const HorizontalBullet = styled.div`
  height: 10px;
  margin: 10px 3px;
  background-color: ${({ isCurrentSlide }) => (isCurrentSlide ? '#76CBC4' : 'rgba(0, 0, 0, 0.06)')};
  width: ${({ isCurrentSlide }) => (isCurrentSlide ? '20px' : '10px')};
  border-radius: 10px;
  cursor: pointer;
  transition: width .1s;
`;

const OpacityAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ArrowsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 5px;

  & > button {
    color: #fff;

    &:hover {
      background-color: #269EE2;
      opacity: 0.7;
    }
  }
`;

export {
  Arrow,
  LeftArrow,
  RightArrow,
  HorizontalBullet,
  OpacityAnimation,
  ArrowsContainer
};
